import TreeView, { flattenTree } from "react-accessible-treeview";
import { useGetOne } from 'react-admin';
import { CircularProgress, Paper } from '@material-ui/core';

const RenderTree = (resource, resourceId) => {
    const { data, isLoading, error } = useGetOne(resource, resourceId);
    if (isLoading) {
        return (<CircularProgress></CircularProgress>)
    }
    if (error) {
        console.log(error);
        return (<span>Error loading data</span>)
    }
    if (!data) {
        console.log(data);
        return (<Paper>No data</Paper>)
    }
    const treeData = flattenTree(data);
    return (
        <div>
            <strong>{data.name}</strong>
            <TreeView
                data={treeData}
                nodeRenderer={({ element, getNodeProps, level, handleSelect }) => (
                    <Paper {...getNodeProps()} style={{ paddingLeft: (level - 1), margin: '1em' }}>
                        {element.name}
                    </Paper>
                )}
            />
        </div>
    )
}
export default RenderTree;